export const COLORS = {
  MAIN_BLUE: "#274c77",
  ACTIVE_BLUE: "#191970",
  LIGHT_BLUE: "#a3cef1",
  ACTIVE_BLUE_LIGHT: "#B2BDFF",
  RICH_BLACK: "#03071E",
  CHOCOLOATE_COSMOS: "#370617",
  ROSEWOOD: "#6A040F",
  PENN_RED: "#9D0208",
  ENGINEERING_ORANGE: "#D00000",
  SINOPIA: "#DC2F02",
  PERSIMMON: "#E85D04",
  PRINCETON_ORANGE: "#F48C06",
  ORANGE_WEB: "#FAA307",
  SELECTIVE_YELLOW: "#FFBA08",
  FRENCH_GRAY_LIGHT: "#CED4DA",
  FRENCH_GRAY_DARK: "#ADB5BD",
  ANTI_FLASH_WHITE: "#E9ECEF",
  MAIN_GREY: "#8b8c89",
  MEDIUM_BLUE: "#6096ba",
  LIGHT_GREY: "#e7ecef",
};

export const MAIN_PALLETE = {
  LIGHT_GREY: "#e7ecef",
  DARK_BLUE: "#274c77",
  MEDIUM_BLUE: "#6096ba",
  LIGHT_BLUE: "#a3cef1",
  MAIN_GREY: "#8b8c89",
  BLACK: "#000000",
  MAIN_BACKGROUND: "#495057",
  DARK_OUTLINE: "#000000",
  SECONDARY_BACKGROUND: "#777D88",
  BUTTON_DARK: "#425465",
  ADD_GREEN: "#a3b18a",
  WHITE: "#FFFFFF",
};

export const UTIL_BUTTON_PALLETE = {
  ADD_GREEN: "#a3b18a",
  CANCEL_RED: "#e35053",
  BUTON_COLOR: "#949a94",
  BUTTON_HOVER: "#A9a9a9",
};
